// TODO(keep): Refactored file to keep
import { z } from 'zod'

export const paginationQueryParamsSchema = z.object({
  itemsPerPage: z.coerce.number().default(10).optional(),
  page: z.coerce.number().default(1).optional(),
})

export type PaginationQueryParams = z.infer<typeof paginationQueryParamsSchema>
